import { useTranslations } from 'next-intl';

type BatchNameBadgeProps = {
  batchName: string;
};

export default function BatchNameBadge({ batchName }: BatchNameBadgeProps) {
  const t = useTranslations();

  return (
    <span className="bg-gradient-to-br from-gray-50 to-gray-100/50 text-sm items-center gap-2 p-1 px-2 rounded-sm w-fit inline ml-2 -mt-1 whitespace-nowrap border-1	border-primary-200">
      {t('course-card-live.batch')} {batchName}
    </span>
  );
}
